export default __webpack_public_path__ + "static/media/sign_up_middle_up.18a05d73.png";